import { defineStore } from "pinia";

export const usePlugins = defineStore("plugins", () => {
  // This is a dummy component to enable use of the plugin properties in other stores.
  // It's a wierd quirk where pinia stores cannot access plugin props directly.
  // Any pinia store can access plugin props through literally any other store.
  // This helper isn't necessary but it keeps things clearer as we aren't calling random stores just to access plugin props.
  //
  // For example:
  // ------ ReachStore.ts ------
  // this.$ws --> undefined
  // $ws --> undefined
  // const { $ws } = useClientStore(); --> works, but confusing why we're calling useClientStore() in a store that has nothing to do with it.
  // const { $ws } = usePlugins(); --> works, and is clearer that we're just accessing the plugin props.
  // ------ ReachStore.ts ------
  return {} as { $ws: any; $pluralize: any };
});
